module.exports = __webpack_public_path__ + "img/26.6ae3c30f.gif";